import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  INJECTOR,
  input,
  model,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  SearchResultRenderer,
  ShellSearchService,
  SOFT_SHELL_SAVE_LAST_VIEWED,
  SOFT_SHELL_SEARCH_DISMISS,
} from '@softapps/core';
import { IconComponent, TranslatePipe } from '@softline/ui-core';
import { MediaPipe } from '../../pipes/media.pipe';
import { Item } from '../../types/item';

@Component({
  selector: 'soft-item-search-result',
  imports: [IconComponent, TranslatePipe, MediaPipe],
  templateUrl: './item-search-result.component.html',
  styleUrl: './item-search-result.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(keydown.enter)': 'openProductDetailView(this.result())',
  },
})
export class ItemSearchResult extends SearchResultRenderer<Item> {
  override result = input.required<Item>();
  override highlighted = input(false);
  override disabled = model(false);

  readonly router = inject(Router);
  readonly injector = inject(INJECTOR);
  readonly overlay = inject(CdkConnectedOverlay);
  readonly shellSearchService = inject(ShellSearchService);

  readonly dismissSearchOverlay = inject(SOFT_SHELL_SEARCH_DISMISS);
  readonly saveLastViewed = inject(SOFT_SHELL_SAVE_LAST_VIEWED, { optional: true });

  async openProductDetailView(result: Item) {
    this.saveLastViewed?.({
      key: String(result.id),
      number: result.number,
      title: result.name,
      subtitle: result.matchcode,
      //url: `/artikel-info/${result.id}`,
    });
    this.dismissSearchOverlay();
    await this.router.navigate(['/artikel-info', result.id], {
      state: { fromSearch: true },
    });
  }
}
